export default __webpack_public_path__ + "static/media/medical_device_image_4.caf52237.jpg";